import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { NakedButton } from '@frontend/design-system';

const styles = {
  linkButton: css`
    color: ${theme.colors.primary50};
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.large};
  `,
};

type SkipButtonProps = {
  onSkip?: () => void;
};

export function SkipButton({ onSkip }: SkipButtonProps) {
  const { t } = useTranslation('account');

  const onClick = () => {
    onSkip?.();
  };

  return (
    <div
      css={css`
        text-align: center;
        margin: ${theme.spacing(6)} 0;
      `}
    >
      <NakedButton css={styles.linkButton} onClick={onClick}>
        {t('Skip and Enable Later')}
      </NakedButton>
    </div>
  );
}
